// removed by extract-text-webpack-plugin
module.exports = {"block":"MainMenuUserHuge__block-3CeHU","avatar":"MainMenuUserHuge__avatar-1sGae","title":"MainMenuUserHuge__title-3uS8d","balance":"MainMenuUserHuge__balance-1XoaH"};